import React, { Component } from "react";
import { convertStringToElements } from "@vds/html-parsers";
import styled from "styled-components";
import PropTypes from "prop-types";
import moment from "moment";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Radio as ReactRadio } from "common-components/FormContent";
import { Input } from "@vds/inputs";
import { TitleLockup } from "@vds/type-lockups";
import { RadioButton } from "@vds/radio-buttons";
// import { Input as ReactInput, Label } from "@vzrf/react-forms";    // changes

import { downloadAmountChanged, customDateRangeChanged, getPreviousDate } from "../actions";
import { setA11yContent } from "../../NavigationHelper/actions";
import { media, isMobile } from "utils/style";
import { checkNestedObject } from "utils/checkNestedObject";
import { replaceHashValues } from "utils/replaceHashValues"; //changes
import { checkAMLob } from "utils/checkAMLob";

import CommonHeader from "common-components/Header";
import CommonContainer from "common-components/Container";
import Button from "common-components/Buttons";
import Warning from "../../../../../assets/svgs/Warning.svg";
import SuccessInputImg from "../../../../../assets/svgs/SuccessInputImg.svg";
const pattern = /^\d{2}\/\d{2}\/\d{4}$/;
class DownloadAmount extends Component {
  state = {
    invalidDates: false,
    startDate: moment(this.props.startDate).format('MM/DD/YYYY'),
    endDate:moment(this.props.endDate).format('MM/DD/YYYY'),
    startError: '',
    endError: '',
    error:''
  };

  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("Download amount", this.props.pageContent.sc_pagetitle);
    }
  }

  componentDidUpdate(prevProps) {
    

    if (this.props.endDate !== prevProps.endDate || this.props.startDate !== prevProps.startDate) {

        if (this.checkDateDifference() < 30) {
          this.props.customDateRangeChanged(moment(getPreviousDate(this.props.endDate)), "startDate");
          this.setState({
            startDate: moment(getPreviousDate(this.props.endDate)).format('MM/DD/YYYY'),
            invalidDates: false,
            error: ''
          })
        }

      // if (this.props.startDate !== prevProps.startDate) {
      //   if (this.checkDateDifference() < 30) {
      //     this.setState({ invalidDates: true });
      //   } else {
      //     if (this.state.invalidDates) {
      //       this.setState({ invalidDates: false });
      //     }
      //   }
      // }
    }
  }

  checkDateDifference = () => {
    const startDate = moment(this.props.startDate);
    const endDate = moment(this.props.endDate);
    const diff = endDate.diff(startDate, "days");

    return diff;
  };

  handleClick = () => {
    if(!this.state.startError && !this.state.endError && !this.state.invalidDates){
      let pathname = "/privacy/secure/file-format-selection";
      if (checkNestedObject(this.props, "location", "state", "fromAuthorizedAgent")) {
        // pathname = "/privacy/secure/authorized-agent/download/review";
        pathname="/privacy/secure/authorized-agent/file-format-selection";
      }

      this.props.history.push({
        pathname,
        state: {
          confirmAuth: true
        }
      });
    }
  };


  handleDownloadAmountChanged = (e) => {
    const selectedOptionItem = this.props.pageContent.genericList[0].list.filter(item => item.jsonKey === e.target.value);
    if (selectedOptionItem && selectedOptionItem.length > 0) {
      const label = selectedOptionItem[0].jsonValue ? selectedOptionItem[0].jsonValue.replace("(recommended)", "") : "";
      this.props.downloadAmountChanged(e, label);
    }
  }
  handleAcctCreationDate=() =>{
    let acctCreationDate = window.reactGlobals.acctCreationDate;

    if (checkAMLob() === "agent") {
      if (checkNestedObject(this.props, "location", "state")) {
        const customerHistory = this.props.location.state.customerHistory;
        if (customerHistory) {
          acctCreationDate = customerHistory.acctCreationDate;
        }
      }
    }
    return acctCreationDate;
  }

  handleStartDateChange =(e) =>{
    this.setState({
      startDate: e.target.value
    })

    const isValidDate = moment(e.target.value,'MM/DD/YYYY',true).isValid();
    
    if(isValidDate){
      this.props.customDateRangeChanged(new Date(moment(e.target.value)),'startDate');
      const inputDate = e.target.value;

      const isEffectiveDate = this.handleAcctCreationDate() ? moment(inputDate,'MM/DD/YYYY').isBefore(this.handleAcctCreationDate()) : moment(inputDate).isBefore('10/07/1983');
      const effectiveDate = this.handleAcctCreationDate() ? moment(this.handleAcctCreationDate()) : moment('10/07/1983');

      if(isEffectiveDate) {

        this.props.customDateRangeChanged(new Date(moment(effectiveDate)),'startDate');
        moment(inputDate) <= moment('10/07/1983') ?
         this.setState({
          startDate: moment(effectiveDate).format('MM/DD/YYYY'),
          invalidDates: false,
          startError: '',
          error:''
        }) :
        this.setState({
          startDate: moment(effectiveDate).format('MM/DD/YYYY'),
          invalidDates: false,
          startError: '',
          error: 'We have updated to your service start date'
        })
      
      } else{

          this.setState({
            startDate: moment(inputDate).format('MM/DD/YYYY'),
            invalidDates: false,
            startError: '',
            error: ''
          });

        }

      } else{
        e.target.value ?
        this.setState({
          invalidDates: false,
          startError: 'Invalid date format',
          error: ''
        })
        :
        this.setState({
          invalidDates: true,
          startError: '',
          error: ''
        })
      }
}
  handleEndDateChange =(e) =>{
    this.setState({
      endDate: e.target.value
    })
    const isValidDate = moment(e.target.value,'MM/DD/YYYY',true).isValid();

    if(isValidDate){

      if(new Date(moment(e.target.value)) > new Date()){  
        this.props.customDateRangeChanged(new Date(),'endDate');
        this.setState({
          endDate: moment(new Date()).format('MM/DD/YYYY'),
          invalidDates: false,
          endError: '',
          error: ''
        })
      } else if(this.handleAcctCreationDate() && new Date(moment(e.target.value)) <= new Date(moment(this.handleAcctCreationDate()).add(30,'days'))){
        this.props.customDateRangeChanged(new Date(moment(this.handleAcctCreationDate()).add(30,'days')),'endDate');
          this.setState({
            endDate:  moment(this.handleAcctCreationDate()).add(30,'days').format('MM/DD/YYYY'),
            invalidDates: false,
            startError: '',
            endError: '',
            error: ''

          })

      } else{
        if(new Date(moment(e.target.value)) <= new Date(moment('10/07/1983').add(30,'days'))){
          this.props.customDateRangeChanged(new Date(moment('10/07/1983').add(30,'days')),'endDate');
          this.setState({
            endDate: moment('10/07/1983').add(30,'days').format('MM/DD/YYYY'),
            invalidDates: false,
            endError: '',
            error:''
          })
        } else{
          this.props.customDateRangeChanged(new Date(moment(e.target.value)),'endDate');
          this.setState({
            endDate: moment(e.target.value).format('MM/DD/YYYY'),
            invalidDates:false,
            endError: '',
            error: ''
          })
        }
      }
  } else{
    e.target.value ?
      this.setState({
        invalidDates: false,
        endError: 'Invalid date format',
        error: ''
      }) 
      :
      this.setState({
        invalidDates: true,
        endError: '',
        error: ''
      })
  }

  }

  render() {
    const { pageContent } = this.props;
    const { cpraFlagEnabled } = window.reactGlobals;

    if (!pageContent) {
      return <Redirect to="/privacy/secure/your-data" />;
    }



    return (
      <Container>
        <div style={{ maxWidth: "595px" }}>
        <TitleLockup 
              surface= 'light'
              textAlignment= 'left'
              viewport={isMobile ? "mobile": "desktop"}
              data={{
                 title:{
                  size:'titleXLarge',
                  bold: false,
                  children: convertStringToElements(pageContent.section_title)
                 },
                 subtitle:{
                    size: 'bodyLarge',
                    primitive:'p',
                    children: convertStringToElements(pageContent.section_description)
                    }

               }}
            
            
        />
          {/* <Header>{convertStringToElements(pageContent.section_title)}</Header>
          <P>{convertStringToElements(pageContent.section_description)}</P> */}
        </div>
        <fieldset style={{  padding: "6px 26px 24px 38px", margin: "24px 0 48px 0" }}>
          {/* <Legend htmlFor="download_amount" style={{ color: "#747676" }}>
            {convertStringToElements(pageContent.genericList[0].text)}
          </Legend> */}
          {pageContent.genericList[0].list.map(item => {
            if (item && item.jsonKey.toLowerCase() === "custom" && undefined !== cpraFlagEnabled && "N" === cpraFlagEnabled) {
              return false;
            }
            if (item && item.jsonKey.toLowerCase() === "custom") {
              return (
                <CustomContainer activeContainer={this.props.downloadAmount.toLowerCase() === "custom"} key={item.jsonKey}>
                  
                  <RadioButton
                  name="downloadAmount"
                  children={<span style={{marginLeft:"-28px"}}>{item.jsonValue}</span>}
                  ariaLabel={item.jsonValue}
                  value={item.jsonKey}
                  selected={item.jsonKey === this.props.downloadAmount}
                  onChange={this.handleDownloadAmountChanged}
                  />
                
                  <CalanderWrapper active={this.props.downloadAmount.toLowerCase() === "custom"}>
                    <InputContainer> 
                     
                      <Input                           
                        type= "date"
                        name="startDate"
                        label={pageContent.genericList[0].startText}
                        readOnly={false}
                        required={true}
                        value= {this.state.startDate}                                          
                        ariaLabel={!this.state.startDate ? 'Start date (MM/DD/YYYY)' : pageContent.genericList[0].startText+' (MM/DD/YYYY)'}
                        error={this.state.startError || this.state.error ? true : false}
                        errorText={this.state.startError && !this.state.error ? this.state.startError : !this.state.startError && this.state.error ? this.state.error : "" }                                                                                       
                        onChange={this.handleStartDateChange}
                      />
                       
                    </InputContainer>
                    <InputContainer>
                    
                      <Input
                        type= "date"
                        name="endDate"
                        label={pageContent.genericList[0].endText} 
                        readOnly={false}
                        required={true}
                        value={this.state.endDate}
                        ariaLabel={!this.state.endDate? 'End date (MM/DD/YYYY)' : pageContent.genericList[0].endText+' (MM/DD/YYYY)'}
                        error={this.state.endError ? true : false}
                        errorText={this.state.endError ? this.state.endError : "" }    
                        onChange={this.handleEndDateChange}
                        selectedDate={new Date(this.props.endDate)}
                      />

                    </InputContainer>
                  </CalanderWrapper>
                </CustomContainer>
              );
            }
            return (
              <div style={{margin:"24px 0px"}}>
              <RadioButton
                key={item.jsonKey}
                name="downloadAmount"
                children={<span style={{marginLeft:"-28px"}}>{item.jsonValue}</span>}
                ariaLabel={item.jsonValue}
                margin-left="-15px"
                value={item.jsonKey}
                selected={item.jsonKey === this.props.downloadAmount}
                onChange={this.handleDownloadAmountChanged}
              />

              </div>
              
            );
          })}
        </fieldset>

        <Button
          background={pageContent.buttons[0].type}
          // disabled={this.state.invalidDates}
          onClick={this.handleClick}
        >
          {pageContent.buttons[0].text}
        </Button>

        {checkNestedObject(pageContent, "genericList", [0], "customDescription") ? (
          <div style={{ maxWidth: "434px", marginTop: "22px" }}>
            {convertStringToElements(pageContent.genericList[0].customDescription)}
          </div>
        ) : null}
      </Container>
    );
  }
}

const mapStateToProps = ({ pageContent, downloadAmount: { downloadAmount, startDate, endDate } }) => ({
  pageContent: pageContent.download_amount,
  downloadAmount,
  startDate,
  endDate
});

DownloadAmount.propTypes = {
  downloadAmountChanged: PropTypes.func.isRequired,
  pageContent: PropTypes.object.isRequired
};

export default connect(
  mapStateToProps,
  { downloadAmountChanged, customDateRangeChanged, setA11yContent }
)(DownloadAmount);

const P = styled.p`
 font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
 font-size: 16px;
 font-style: normal;
 font-weight: 400;
 line-height: 20px; 
 letter-spacing: 0.5px; 
`;

const Radio = styled(ReactRadio)`
  margin: 24px 0;
  z-index: 10;
`;

const Legend = styled.legend`
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
`;

const CustomContainer = styled.div`
  
  margin: -6px 0px;

  ${({ activeContainer }) =>
    activeContainer &&
    `
    background-color: #f8f8f8;
  `}

  > * {
    &:first-child {
      margin: 0 0 20px 0;
    }
  }
`;
// const Input = styled(ReactInput)`
//   width: 100%;
//   border: 1px solid #6F7171;
//   border-radius: 4px;
//   ${media.mobile`
//     width: 100%;
//   `}
// `;
const InputContainer = styled.div`
  flex: 50%;
  margin-top: 14px;
  box-sizing: border-box;
  padding-right: 20px
  div {
    display: block;
  }
    
  ${media.mobile`
    flex: 100%;
  `}
`;
// const ErrorMsg = styled.span`
//   display: block;
//   font-size: 10px;
//   line-height: 10px;
//   font-family: "Verizon-NHG-eTX", Helvetica, Arial, sans-serif;
//   max-width: 464px;
//   margin-top: 5px;
//   position:absolute;
//   color:#C44904;

//   ${media.mobile`
//     max-width: 100%;  
//   `}
// `;
// const UpdateMsg = styled.span`
//   display: block;
//   font-size: 10px;
//   line-height: 10px;
//   font-family: "Verizon-NHG-eTX", Helvetica, Arial, sans-serif;
//   max-width: 464px;
//   margin-top: 5px;
//   position:absolute;
//   color:black;

//   ${media.mobile`
//     max-width: 100%;  
//   `}
// `;

const CalanderWrapper = styled.div`

  ${({ active }) =>
    active ?
      (`
    display: flex;
    justify-content: space-between;
  `) :
      (
        !active ? (`
      display: none;
      pointer-events: none;
    `) :
          ``
      )
  }

  ${media.mobile`
    flex-direction: column;
  `}
`;

const CalanderContainer = styled.div`
  flex-basis: 328px;

  ${media.mobile`
    flex-basis: 100%;

    &:first-of-type {
      margin-bottom: 18px;
    }
  `}
`;

const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 64px 20px ;
  ${media.mobile`
    margin: 0;
    padding: 32px 16px ;
  `}
`;

const Header = styled(CommonHeader)`
  max-width: 598px;
  font-size: 48px;
  line-height: 48px;
  margin-bottom: 12px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-weight: 300;

${media.mobile`
  font-size: 32px;	
  line-height: 36px;
  font-weight: 300;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
`}
`;

const Span = styled.span`
font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 24px;

  ${media.mobile`
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;  
  `};
`;